/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';

const HorseTrackerButton = ({ className, label, iconName, onClick }) => (
    <button
        className={classNames('hp-horseTracker__button ui-btn ui-btn_primary', className)}
        onClick={onClick}
    >
        <span className="hp-horseTracker__label">{label}</span>
        {iconName ? (
            <Svg
                iconName={iconName}
                size={iconName === 'tracker' ? 'Medium' : 'Medium'}
            />
        ) : null}
    </button>
);

HorseTrackerButton.propTypes = {
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

export default HorseTrackerButton;



// WEBPACK FOOTER //
// ./src/js/shared/horseTracker/HorseTrackerButton.jsx